import { type TournamentDeskUISettings } from 'components/dialogs/draw/publicDrawDisplaySettings/types';
import { type DragObjectItemInterface, DropTypeEnum } from 'components/tables/dndVirtualizedTable/typedefs';
import { type FlightProfile, type ParticipantInterface } from 'typedefs/store/tmxTypes';

export const renderDraws = (flights: FlightProfile[], player: ParticipantInterface) =>
  (flights || []).filter((flight) =>
    flight?.drawEntries?.find((entry) => entry.participantId === player.participantId),
  );

export const handleReorderParticipants = ({
  participants,
  dragObject,
  endIndex,
  dropType,
  setEntryPositionsState,
}: {
  participants: ParticipantInterface[];
  dragObject: DragObjectItemInterface<any>;
  endIndex: number;
  dropType: DropTypeEnum;
  setEntryPositionsState: (entryPositions: { participantId: string; entryPosition: number }[]) => void;
}) => {
  if (dropType === DropTypeEnum.REORDER_ROWS) {
    const movedItem = participants.find((participant) => participant.participantId === dragObject.item.id);
    const remainingItems = participants.filter((item, index) => {
      return index !== dragObject.startIndex;
    });
    const updatedParticipantsOrder = [
      ...remainingItems.slice(0, endIndex),
      movedItem,
      ...remainingItems.slice(endIndex),
    ].map((entry, index) => ({
      participantId: entry.participantId,
      entryPosition: index + 1,
    }));
    setEntryPositionsState(updatedParticipantsOrder);
  }
};

export const getOrderedParticipants = (participants: ParticipantInterface[]) =>
  participants.map((entry, index) => ({
    participantId: entry.participantId,
    entryPosition: index + 1,
  }));

export const getIsUpdateWithdrawnColumns = ({
  isTeam,
  isTeamPlayersTable,
  selectedColumns,
  tournamentDeskUI,
}: {
  isTeam: boolean;
  isTeamPlayersTable: boolean;
  selectedColumns: string[];
  tournamentDeskUI: TournamentDeskUISettings;
}) => {
  if (
    isTeamPlayersTable &&
    JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.teamsWithdrawnPlayersColumns)
  )
    return;
  if (
    isTeam &&
    !isTeamPlayersTable &&
    JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.teamsWithdrawnTeamsColumns)
  )
    return;
  if (!isTeam && JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.singlesDoublesWithdrawnColumns))
    return;

  return true;
};
